<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/subjective-detection_example.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("subd.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"text":["Das Handy ist sehr schön finde ich."]}
                    </p>

                    <h4 class="font-weight--light">{{ $t("subd.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"classifications":[{"input_text":"Das Handy ist sehr schön finde ich.","label":"subjective","label_num":1,"certainty":0.9996559619903564}]}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
